import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  ReservationInitModel,
  ReservationInitVariables,
  ReservationModel,
  ReservationVariables,
} from '../../../../../models/email-template/reservation.interface'
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-reservation',
    imports: [
        CommonModule,
        NotificationComponent,
        ReactiveFormsModule,
        BlockTextComponent,
        PinComponent,
    ],
    templateUrl: './reservation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './reservation.component.scss'
})
export class ReservationComponent extends BaseComponent implements OnInit {
  @Input() block: ReservationModel = new ReservationInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ReservationInitVariables()
    }
  }

  //placeholders:
  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image1HrefPlaceholder: string = 'Enter Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  namePlaceholder: string = 'Enter Property Name';
  addressPlaceholder: string = 'Enter Address';
  telephonePlaceholder: string = 'Enter Telephone Number';
  checkInPlaceholder: string = 'Enter Check-In Time';
  checkOutPlaceholder: string = 'Enter Check-Out Time';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ReservationVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ReservationVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
